import type { FC } from "react";

import {
  TABS_DEFAULTS,
  type TTabsTriggerVariantProps,
  type TTabsTriggersProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { TabsTrigger } from "@/ui/components/navigation/Tabs/TabsTrigger";

export const TabsTriggers: FC<TTabsTriggersProps> = ({
  tabs,
  triggerClassName,
  variant = TABS_DEFAULTS.variant,
}) => tabs.map((tab) => {
  const variantProps: TTabsTriggerVariantProps = tab.icon
    ? { icon: tab.icon, variant: "icon" }
    : { variant: variant as Exclude<typeof variant, "icon"> };

  return (
    <TabsTrigger
      key={tab.value}
      value={tab.value}
      disabled={tab.disabled}
      description={tab.description}
      className={triggerClassName}
      {...variantProps}
    >
      { tab.label }
    </TabsTrigger>
  );
});

TabsTriggers.displayName = "TabsTriggers";
